
const useIntersectionObserver = (el, binding) => {
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        binding.value(el.id, true) // 元素进入可视区域
      } else {
        binding.value(el.id, false) // 元素离开可视区域
      }
    })
  })
  observer.observe(el)
}

const vVisible = {
  inserted(el, binding) {
    if (typeof binding.value !== 'function') {
      console.error('The binding value for v-visible must be a function')
      return
    }
    useIntersectionObserver(el, binding)
  }
}

export const visible = vVisible
